








import {Component, Vue, Prop} from 'vue-property-decorator'

@Component({})
export default class Modal extends Vue {
  @Prop({type: String, default: ''}) public positionClass!: string
}
